

















































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import echarts from "echarts";
import { PostShitiHengji, GetShuxinglaiyuanOptions } from "@/request/check";
import { AddShiti, GetShitiList, GetLeftCategory } from "@/request/storehouse";
import { GetTupu } from "@/request/tupu";
import { PatchConceptualEntity } from "@/request/common";
import Empty from "@/components/empty.vue";
@Component({
  components: {
    Empty,
  },
})
export default class Name extends Vue {
  @Prop() disabledShangweigainian: any; // 是否禁止修改上位概念
  @Prop() hideBtn: any; // 是否隐藏按钮
  @Prop() type: any; // 有值表示是校验痕迹详情，校验痕迹详情的接口不一样
  @Prop() kind: any; // 知识库类型
  @Prop() id: any;
  @Watch("id")
  private idChange(newVal: any, oldVal: any) {
    console.log("idChange");
    this.getData();
  }
  private cTab: any = "通用";
  private ifShowShangweigainian: any = false;
  private data: any = {
    上位概念: [],
  };
  private tupuData: any = {};
  private tijiaoData: any = {
    select: [],
    text: "",
  };
  private ifShowSaveConfirm: any = false;
  private ifShowTijiao: any = false;
  private curSourceData: any = {};
  private ifShowSource: any = false;
  private curSource: any = ""; //添加来源页面的值
  private sources: any = [];
  private colors: any = [
    "#FFA7CC",
    "#46AAAA",
    "#FFAA6A",
    "#A185D3",
    "#82D1F1",
    "#EC7E68",
    "#F6C63C",
    "#7784A2",
    "#75DDB5",
    "#759FFC",
    "#FFA7CC",
    "#46AAAA",
    "#FFAA6A",
    "#A185D3",
    "#82D1F1",
    "#EC7E68",
    "#F6C63C",
    "#7784A2",
    "#75DDB5",
    "#759FFC",
    "#FFA7CC",
    "#46AAAA",
    "#FFAA6A",
    "#A185D3",
    "#82D1F1",
    "#EC7E68",
    "#F6C63C",
    "#7784A2",
    "#75DDB5",
    "#759FFC",
    "#FFA7CC",
    "#46AAAA",
    "#FFAA6A",
    "#A185D3",
    "#82D1F1",
    "#EC7E68",
    "#F6C63C",
    "#7784A2",
    "#75DDB5",
    "#759FFC",
  ];
  private props: any = {
    label: "name",
  };
  private ifShowTree: any = false;
  private expandedNode: any = [];
  private get ifCompose() {
    return this.$store.state.ifCompose;
  }
  private edit() {
    this.$store.commit("updateIfCompose", true);

    this.selectGainian();
  }
  private removeGainian(item: any, index: any) {
    this.data['上位概念'].splice(index,1);
    // 更新optionWrap的选择
    this.selectGainian();
  }
  private selectGainian() {
    this.$nextTick(() => {
      const tree = this.$refs.optTree as any;
      if (tree) {
        if (this.data["上位概念"] && this.data["上位概念"].length > 0) {
          let ids: any = [];
          // 选中
          this.data["上位概念"].forEach((ele: any) => {
            ids.push(ele["id"]);
          });
          this.expandedNode = ids;
          tree.setCheckedNodes(this.data["上位概念"]);
          tree.setCheckedKeys(ids);
          const checkData: any = tree.getCheckedNodes();
          console.log(checkData);
        } else {
          // 如果没有上位概念，清空选择
          this.expandedNode = [];
          tree.setCheckedNodes([]);
          tree.setCheckedKeys([]);
        }
      }
    });
  }
  private loadNode(node: any, resolve: any) {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        _id: node.data ? node.data._id : "",
        语义id: this.data["语义id"],
      },
    };
    GetLeftCategory(this, params, loading)
      .then((res: any) => {
        loading.close();
        let d: any = [];
        res.forEach((ele: any) => {
          if (ele.id === this.data.id) {
            ele.disabled = true;
          }
        });
        // 选中当前的节点
        const currentNode = res.find((ele: any) => {
          return ele.id === this.data.id;
        });
        if (currentNode) {
          currentNode.checked = true;
        }
        resolve(res);
      })
      .catch(() => {
        loading.close();
        resolve([]);
      });
  }
  private handleCheckChange(data: any, checked: any, indeterminate: any) {
    // 手动维护 data["上位概念"]，只增删当前节点
    const idx = this.data["上位概念"].findIndex((item: any) => item.id === data.id);
    if (checked && idx === -1) {
      this.data["上位概念"].push(data);
    } else if (!checked && idx !== -1) {
      this.data["上位概念"].splice(idx, 1);
    }
    // 保证已选中的节点在树中被选中
    this.$nextTick(() => {
      const tree = this.$refs.optTree as any;
      if (tree && this.data["上位概念"].length > 0) {
        const checkedKeys = this.data["上位概念"].map((item: any) => item.id);
        tree.setCheckedKeys(checkedKeys);
      }
    });
    this.$forceUpdate();
  }
  private openSource(item: any) {
    this.curSourceData = item;
    this.ifShowSource = true;
    this.curSource = "";
  }
  private addSource() {
    this.curSourceData.source = this.curSource;
    this.getSources();
    this.ifShowSource = false;
  }
  private forceUpdate() {
    this.$forceUpdate();
  }
  private deleteSource(item: any) {
    if (!this.ifCompose) {
      return;
    }
    item.source = "";
  }
  private remoteSource(e: any) {
    this.getSources(e);
  }
  private getSources(e?: any) {
    const params: any = {
      params: {
        search: e,
      },
    };
    GetShuxinglaiyuanOptions(this, params).then((res: any) => {
      this.sources = res;
    });
  }
  private clickTijiao() {
    if (!this.data["实体名称"]) {
      this.$message.warning("实体名称缺失，请补充完善后提交！");
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    AddShiti(this, this.data, loading).then((res: any) => {
      loading.close();
      this.$message.success("保存成功！");
      this.$store.commit("updateIfCompose", false);
      this.getData();
    });
    // this.tijiaoData = {
    //   select: [],
    //   text: "",
    // };
    // this.ifShowTijiao = true;
  }
  private changePart(index: any) {
    const parant: any = document.getElementById("scrollBox");
    const children: any = document.getElementById("scrollBox" + index);
    if (parant) {
      if (children) {
        const parentTop = parant.offsetTop;
        const childTop = children.offsetTop;
        parant.scrollTop = childTop - parentTop - 14;
      }
    }
  }
  private input(e: any) {
    const index = this.tijiaoData.select.indexOf("其它");
    if (index === -1) {
      this.tijiaoData.select.push("其它");
    }
  }
  private tijiaoSure() {
    if (this.tijiaoData.select.length == 0) {
      this.$message.warning("请先选择本次修改的内容再提交");
      return;
    }
    const index = this.tijiaoData.select.findIndex((v: any) => {
      return v === "其它";
    });
    let result: any = [];
    if (index === -1) {
      result = this.tijiaoData.select;
    } else {
      if (this.tijiaoData.text) {
        result = this.tijiaoData.select;
        result[index] = "其它，" + this.tijiaoData.text;
      } else {
        result = this.tijiaoData.select;
      }
    }
    this.data.texts = result.join("、");
    AddShiti(this, this.data).then((res: any) => {
      this.$message.success("提交成功！");
      this.$store.commit("updateIfCompose", false);
      this.ifShowTijiao = false;
      this.getData();
    });
  }
  private clickModify(status: any) {
    this.$confirm(
      `确定${status == "增补-已通过" ? "通过" : "打回"}么？`,
      "提示",
      {
        customClass: "commonConfirm",
      }
    ).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      PatchConceptualEntity(
        this,
        this.data.id,
        {
          是否临时: status,
        },
        loading
      ).then((res: any) => {
        loading.close();
        this.getData();
        this.$store.commit("updateIfCompose", false);
      });
    });
  }
  private tijiao() {
    this.ifShowSaveConfirm = false;
    this.clickTijiao();
  }
  private back() {
    this.$store.commit("updateIfCompose", false);
    this.$router.back();
  }
  /**
   * @description 离开页面前保存
   */
  private beforeRouteLeave(to: any, from: any, next: any) {
    if (this.ifCompose) {
      this.ifShowSaveConfirm = true;
      next(false);
    } else {
      next(true);
    }
  }
  private drawTupu(d: any) {
    const params: any = {
      params: {
        entity_id: d.entity_id,
        entity_name: d.entity_name,
        entity_type: d.entity_type,
      },
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetTupu(this, params).then((data: any) => {
      loading.close();
      this.tupuData = data;
      data.nodes.forEach((ele: any, index: any) => {
        if (ele.type === "目标") {
          ele.symbol = "roundRect";
          ele.symbolSize = 25;
        } else if (ele.type === "实体") {
          ele.symbolSize = 20;
        } else {
          ele.symbolSize = 1;
        }
      });
      this.$nextTick(() => {
        const Chart: any = echarts.init(
          this.$refs.Echarts1 as HTMLCanvasElement,
          {
            renderer: "canvas",
            useDirtyRect: false,
          }
        );
        const options: any = {
          color: this.colors,
          title: {
            text: "",
            subtext: "",
            top: "bottom",
            left: "right",
          },
          tooltip: {},
          legend: [
            {
              // selectedMode: 'single',
              data: data.categories.map(function (a: any) {
                return a.name;
              }),
            },
          ],
          animationDuration: 1500,
          animationEasingUpdate: "quinticInOut",
          series: [
            {
              name: "",
              type: "graph",
              layout: "force",
              data: data.nodes,
              links: data.links,
              categories: data.categories,
              zoom: 3,
              roam: true,
              label: {
                show: true,
                position: "inside",
                formatter: "{b}",
                color: "#333",
              },
              edgeLabel: {
                show: true,
                formatter: (res: any) => {
                  return res.data.name;
                },
              },
              edgeSymbol: ["", "arrow"],
              lineStyle: {
                color: "#333",
                width: 1,
                curveness: 0.1,
              },
              emphasis: {
                show: false,
                focus: "adjacency",
                lineStyle: {
                  width: 6,
                },
              },
            },
          ],
        };
        Chart.setOption(options, true);
        // 添加窗口大小变化监听
        window.addEventListener("resize", () => {
          Chart.resize();
        });
        // 确保图表大小正确
        Chart.resize();
      });
    });
  }
  private getData() {
    console.log(this.type);
    if (!this.id) {
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    if (!this.type) {
      const params: any = {
        params: {
          table_name: this.kind,
          id: this.id,
          need_attr_split: true,
        },
      };
      GetShitiList(this, params)
        .then((res: any) => {
          console.log("实体数据");
          console.log(res);
          loading.close();
          this.data = res;
          this.$emit("data", res);
          this.chuliData();
          const d: any = {
            entity_id: res.id,
            entity_name: res["实体名称"],
            entity_type: res["语义类型"],
          };
          this.drawTupu(d);
          // 判断有没有上位概念，如果有需要显示上位概念的修改框
          const params1: any = {
            params: {
              _id: "",
              语义id: this.data["语义id"],
            },
          };
          GetLeftCategory(this, params1).then((msg: any) => {
            if (msg.length > 0) {
              this.ifShowTree = true;
              this.selectGainian();
            }
          });
        })
        .catch((res: any) => {
          loading.close();
        });
    } else {
      const params: any = {
        history_id: this.id,
      };
      PostShitiHengji(this, params, loading)
        .then((res: any) => {
          loading.close();
          this.data = res;
          this.$emit("data", res);
          const data: any = {
            entity_id: res.id,
            entity_name: res["实体名称"],
            entity_type: res["语义类型"],
          };
          this.drawTupu(data);
          this.chuliData();
          this.selectGainian();
        })
        .catch((res: any) => {
          loading.close();
        });
    }
  }
  
  private chuliData() {
    if (this.ifCompose) {
      this.data.attributes.forEach((element: any) => {
        if (element.contents.length == 0) {
          element.contents.push({
            text: "",
            source: "",
          });
        }
      });
      this.data.parent_attributes.forEach((element: any) => {
        if (element.contents.length == 0) {
          element.contents.push({
            text: "",
            source: "",
          });
        }
      });
    }
  }
  private addOne(item: any) {
    item.push({
      text: "",
      source: "",
    });
  }
  private deleteOne(item: any, i: any) {
    item.splice(i, 1);
  }
  private mounted() {
    this.getData();
  }
}
